'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter } from 'next/navigation';
import React from 'react';
import { selectCurrentEscritorio } from '@/features/escritorio/store/crud/selectors';
import { AvisoTrialModal } from '@/shared/components/ui';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { ROTA_ABA_PLANO } from '../avisoPlano';
import { fetchTrialStatus } from '../store/trialStatus';
import { selectItemDoMarcoMaisGrave } from '../store/trialStatus/selectors';
import { avisoDoTrialStatus, jaViuAviso, marcarAvisoVisto } from '../trialAviso';
const ROTAS_SEM_MODAL = ['/notificacoes/criar', '/negociacoes/nova', '/arbitral/novo', '/peticionamento/criar', '/peticionamento/novo', '/onboarding', '/notificacao-self', '/negociacao-self'];

/**
 * Decide se o modal de fim de teste aparece: só ao entrar no app, nunca em cima de um
 * fluxo de criação já começado, e no máximo uma vez por momento em cada sessão.
 * O aviso do canto (AvisoPlanoFlutuante) continua aparecendo depois de fechar o modal.
 */
export const AvisoTrialGate: React.FC = () => {
  const $ = _c(29);
  const pathname = usePathname();
  const router = useRouter();
  const dispatch = useAppDispatch();
  const currentEscritorio = useAppSelector(selectCurrentEscritorio);
  const item = useAppSelector(selectItemDoMarcoMaisGrave);
  const [fechado, setFechado] = React.useState(false);
  const escritorioId = currentEscritorio?.id;
  const isGuestWorkspace = !!currentEscritorio?.guestAccess;
  let t0;
  let t1;
  if ($[0] !== dispatch || $[1] !== escritorioId || $[2] !== isGuestWorkspace) {
    t0 = () => {
      if (isGuestWorkspace || !escritorioId) {
        return;
      }
      dispatch(fetchTrialStatus());
    };
    t1 = [dispatch, isGuestWorkspace, escritorioId];
    $[0] = dispatch;
    $[1] = escritorioId;
    $[2] = isGuestWorkspace;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  React.useEffect(t0, t1);
  let emFluxoDeCriacao;
  let t2;
  let view;
  if ($[5] !== item || $[6] !== pathname) {
    view = item ? avisoDoTrialStatus(item) : null;
    emFluxoDeCriacao = ROTAS_SEM_MODAL.some(rota => pathname.startsWith(rota));
    t2 = view ? jaViuAviso(view.categoria, view.momento) : true;
    $[5] = item;
    $[6] = pathname;
    $[7] = emFluxoDeCriacao;
    $[8] = t2;
    $[9] = view;
  } else {
    emFluxoDeCriacao = $[7];
    t2 = $[8];
    view = $[9];
  }
  const jaVisto = t2;
  if (isGuestWorkspace || !view || fechado || emFluxoDeCriacao || jaVisto) {
    return null;
  }
  let t3;
  if ($[10] !== view.categoria || $[11] !== view.momento) {
    t3 = () => {
      marcarAvisoVisto(view.categoria, view.momento);
      setFechado(true);
    };
    $[10] = view.categoria;
    $[11] = view.momento;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const fechar = t3;
  let t4;
  if ($[13] !== router || $[14] !== view.categoria || $[15] !== view.momento) {
    t4 = () => {
      marcarAvisoVisto(view.categoria, view.momento);
      setFechado(true);
      router.push(ROTA_ABA_PLANO);
    };
    $[13] = router;
    $[14] = view.categoria;
    $[15] = view.momento;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const irParaPlanos = t4;
  let t5;
  if ($[17] !== fechar || $[18] !== irParaPlanos || $[19] !== view.acaoBloqueada || $[20] !== view.dataFim || $[21] !== view.diasRestantes || $[22] !== view.itensPreservados || $[23] !== view.momento || $[24] !== view.possessivoLabel || $[25] !== view.produtoNome || $[26] !== view.unidadeLabel || $[27] !== view.usadoNoTeste) {
    t5 = <AvisoTrialModal produtoNome={view.produtoNome} momento={view.momento} dataFim={view.dataFim} diasRestantes={view.diasRestantes} acaoBloqueada={view.acaoBloqueada} itensPreservados={view.itensPreservados} usadoNoTeste={view.usadoNoTeste} unidadeLabel={view.unidadeLabel} possessivoLabel={view.possessivoLabel} onVerPlanos={irParaPlanos} onClose={fechar} />;
    $[17] = fechar;
    $[18] = irParaPlanos;
    $[19] = view.acaoBloqueada;
    $[20] = view.dataFim;
    $[21] = view.diasRestantes;
    $[22] = view.itensPreservados;
    $[23] = view.momento;
    $[24] = view.possessivoLabel;
    $[25] = view.produtoNome;
    $[26] = view.unidadeLabel;
    $[27] = view.usadoNoTeste;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  return t5;
};